var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/05ca59669f07b9175dd2305d9ef3b005.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/76d94179b8eb792b1b5f1be8777d9d44.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f26e2a1a420ba489b4e60db1a995c23a.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    